import React from 'react';
import { ApiDataFormat } from 'core-lib/types/Network';
import { API_DATA_FORMAT, API_STATUS } from 'core-lib/constants/network';
import { getProfile } from '../services/getProfile';
import { useAuth } from "./useAuth";

interface ApiDataType extends ApiDataFormat {
  data: any;
}

export type OutputType = {
  apiCall: ApiDataType;
  init: () => void;
};

type ArgType = {
  handlePostFetch?: boolean;
};

export function useGetProfile({ handlePostFetch = true }: ArgType): OutputType {
  const [apiCall, setApiCall] = React.useState<ApiDataType>({
    ...API_DATA_FORMAT,
  });
  const {setAuthData}  = useAuth()

  async function init() {
    setApiCall({ ...apiCall, apiStatus: API_STATUS.in_progress });
    const { response, error } = await getProfile();
    if (response) {
      setApiCall({ ...apiCall, apiStatus: API_STATUS.success, data: response });
      if (handlePostFetch) {
        const reqData = {
          profile: response
        }
        setAuthData(reqData)
      }
    }
    if (error) {
      setApiCall({
        ...apiCall,
        apiStatus: API_STATUS.success,
        data: null,
        apiError: error,
      });
    }
  }

  return {
    init,
    apiCall,
  };
}
